/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PharmacyCounselorIndividualDelivery,
  PharmacyCounselorIndividualDeliveryFromJSON,
  PharmacyCounselorIndividualDeliveryToJSON,
  PutIndividualDeliveryRequestBody,
  PutIndividualDeliveryRequestBodyFromJSON,
  PutIndividualDeliveryRequestBodyToJSON,
} from "../models";

export interface DeleteCounselingsIndividualDeliveryRequest {
  counselingId: number;
}

export interface PutCounselingsIndividualDeliveryRequest {
  counselingId: number;
  putIndividualDeliveryRequestBody: PutIndividualDeliveryRequestBody;
}

/**
 *
 */
export class IndividualDeliveryApi extends runtime.BaseAPI {
  /**
   * Delete individual delivery information
   */
  async deleteCounselingsIndividualDeliveryRaw(
    requestParameters: DeleteCounselingsIndividualDeliveryRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling deleteCounselingsIndividualDelivery."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/individual-delivery`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete individual delivery information
   */
  async deleteCounselingsIndividualDelivery(
    requestParameters: DeleteCounselingsIndividualDeliveryRequest,
    initOverrides?: RequestInit
  ): Promise<void> {
    await this.deleteCounselingsIndividualDeliveryRaw(requestParameters, initOverrides);
  }

  /**
   * Update individual delivery information
   */
  async putCounselingsIndividualDeliveryRaw(
    requestParameters: PutCounselingsIndividualDeliveryRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyCounselorIndividualDelivery>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling putCounselingsIndividualDelivery."
      );
    }

    if (
      requestParameters.putIndividualDeliveryRequestBody === null ||
      requestParameters.putIndividualDeliveryRequestBody === undefined
    ) {
      throw new runtime.RequiredError(
        "putIndividualDeliveryRequestBody",
        "Required parameter requestParameters.putIndividualDeliveryRequestBody was null or undefined when calling putCounselingsIndividualDelivery."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/individual-delivery`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "PUT",
        headers: headerParameters,
        query: queryParameters,
        body: PutIndividualDeliveryRequestBodyToJSON(requestParameters.putIndividualDeliveryRequestBody),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyCounselorIndividualDeliveryFromJSON(jsonValue));
  }

  /**
   * Update individual delivery information
   */
  async putCounselingsIndividualDelivery(
    requestParameters: PutCounselingsIndividualDeliveryRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyCounselorIndividualDelivery> {
    return promiseRetry(
      (retry) =>
        this.putCounselingsIndividualDeliveryRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
